import styled from "styled-components";
import { Modal } from "../Modal/Modal";

// export const ModalContainer = styled.div`
//   background-color: white;
//   width: 100%;
//   max-width: 500px;
//   padding: 40px;
// `;

// export const ModalContent = styled.div`
//   background-color: #F3F4F6;
//   border-radius: 8px;
//   padding: 32px;
//   border: 1px solid #dee2e6;
// `;

export const Title = styled.h2`
  margin-bottom: 20px;
  color: #333;
  font-size: 1.5rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Label = styled.label`
  font-size: 1rem;
  color: #666;
`;

export const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

export const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &.confirm {
    background-color: #007bff;
    color: white;

    &:hover {
      background-color: #0056b3;
    }
  }

  &.cancel {
    background-color: #6c757d;
    color: white;

    &:hover {
      background-color: #545b62;
    }
  }
`;
// export const ModalHeader = styled.div`
//   margin-bottom: 24px;
  
//   h2 {
//     margin: 0;
//     color: #0066FF;
//     font-size: 1.25rem;
//     font-weight: 500;
//   }
// `;